
export class CartController {
  /**
   *  Structure of the localStorageData:
   *  cart_entes_localstorage:
   *  items:
   *  id
   *  quantity
   *  name
   *  price
   *  priceNumber
   *  stockQuantity 
   */
  
  static isBrowser() {
    return typeof window !== "undefined"
  }

  static addToCart(prod, quantity = 1, lang = 'es'){
    if (prod.stockStatus === 'IN_STOCK') {
      let cart = CartController.getOrCreateCartIfNoExits(lang);
      const isInCart = cart.items.filter(e => e.id === prod.databaseId);
      if (isInCart.length > 0) {
        quantity = isInCart[0].quantity + quantity;
        //console.log({prodQuantity, res: prod.stockQuantity, q: isInCart[0].quantity})
        if(quantity <= prod.stockQuantity){
          cart.items = cart.items.map(el => {
            if (el.id === prod.databaseId) {
              el.quantity = quantity;
            }
            return el;
          });
        }else{
          return {status: false, message: 'Not enough products'};
        }
      } else {
        if(quantity <= prod.stockQuantity){
          cart.items.push({
            image: prod.image.sourceUrl,
            id: prod.databaseId,
            quantity: quantity,
            name: prod.name,
            price: prod.price,
            priceNumber: parseFloat(prod.price.replace('S/&nbsp;', ' ').replace(',', '')),
            stockQuantity: prod.stockQuantity,
          });
        }else{
          return {status: false, message: 'Not enough products (2)'};
        }
      }
      return CartController.setNewCart(cart, lang);
    }else{
      return {status: false, message: "There isn't stock"};
    }
  }

  /**
   *
   * @param prod ProductObject
   * @param prodQuantity
   */
  static appendToCart(prodId, prodQuantity = 1, stock, lang = 'es') {
    let cart = CartController.getOrCreateCartIfNoExits(lang);
    const isInCart = cart.items.filter(e => e.id === prodId);
    if (isInCart.length > 0) {
      prodQuantity = isInCart[0].quantity + prodQuantity;
      console.log({prodQuantity, res: stock, q: isInCart[0].quantity})
      if(prodQuantity <= stock && prodQuantity > 0){
        cart.items = cart.items.map(el => {
          if (el.id === prodId) {
            el.quantity = prodQuantity;
          }
          return el;
        });
      }else{
        return {status: false, message: 'Not enough products'};
      }
      return CartController.setNewCart(cart, lang);
    }else{
      return {status: false, message: 'Is not that product in cart'}
    }
  }

  /**
   *
   * @param prod
   * @param lang
   * @returns {{message: string, status: boolean}|any}
   */
  static addOneMoreItemToCart(prod, lang = 'es') {
    let prodQuantity = 1;
    if (prod.stockStatus === 'IN_STOCK') {
      let cart = CartController.getOrCreateCartIfNoExits(lang);
      const isInCart = cart.items.filter(e => e.id === prod.databaseId);
      if (isInCart.length > 0) {
        prodQuantity = isInCart[0].quantity + prodQuantity;
        //console.log({prodQuantity, res: prod.stockQuantity, q: isInCart[0].quantity})
        if(prodQuantity <= prod.stockQuantity){
          cart.items = cart.items.map(el => {
            if (el.id === prod.databaseId) {
              el.quantity = prodQuantity;
            }
            return el;
          });
        }else{
          return {status: false, message: 'Not enough products'};
        }
      } else {
        if(prodQuantity <= prod.stockQuantity){
          cart.items.push({
            image: prod.image.sourceUrl,
            id: prod.databaseId,
            quantity: prodQuantity,
            name: prod.name,
            price: prod.price,
            priceNumber: parseFloat(prod.price.replace('S/&nbsp;', ' ').replace(',', '')),
            stockQuantity: prod.stockQuantity,
          });
        }else{
          return {status: false, message: 'Not enough products (2)'};
        }
      }
      return CartController.setNewCart(cart, lang);
    }else{
      return {status: false, message: "There isn't stock"};
    }
  }

  /**
   *
   * @param prod
   */
  static deleteFromCart(prodId, lang = 'es') {
    let cart = CartController.getOrCreateCartIfNoExits(lang);
    cart.items = cart.items.filter(e => e.id !== prodId);
    return CartController.setNewCart(cart, lang);
  }

  /**
   *
   * @param prod
   * @param newQuantity
   */
  static changeQuantity(prod, newQuantity, lang = 'es') {
    let cart = CartController.getOrCreateCartIfNoExits(lang);
    let flag = false;
    if(newQuantity <= prod.stockQuantity){
      cart.items = cart.items.map(el => {
        if (el.id === prod.databaseId) {
          el.quantity = newQuantity;
          flag = true;
        }
        return el;
      });
    }else{
      return {status: false, message: 'Not enough products'};
    }
    if(flag){
      return CartController.setNewCart(cart);
    }else{
      return {status: false, message: 'Product not found'};
    }
  }

  /**
   *
   */
  static getOrCreateCartIfNoExits(lang = false) {
    if(!CartController.isBrowser()){
      return {
        items: []
      };
    }
    let cart = window.localStorage.getItem('_cart_entes_localstorage');
    console.log(cart);
    if (!cart) {
      cart = {
        en: {
          items: []
        },
        es: {
          items: []
        }
      };
      window.localStorage.setItem('_cart_entes_localstorage', JSON.stringify(cart));
    } else {
      cart = JSON.parse(cart);
    }
    if(lang)
      return cart[lang];
    return cart;
  }

  static setNewCart(cart, lang = 'es') {
    if(!CartController.isBrowser()){
      return false;
    }
    const oldCart = CartController.getOrCreateCartIfNoExits();
    console.log({oldCart});
    oldCart[lang] = cart;
    window.localStorage.setItem('_cart_entes_localstorage', JSON.stringify(oldCart));
    return  JSON.parse(window.localStorage.getItem('_cart_entes_localstorage'));
  }

  static dropAll(){
    if(!CartController.isBrowser()){
      return false;
    }
    window.localStorage.clear('_cart_entes_localstorage');
  }

  static getCartQueryString(lang='es' ){
      const cart = CartController.getOrCreateCartIfNoExits(lang);
      let finalQuery = '?';
      for(const item of cart.items){
        finalQuery = `${finalQuery}atc[${item.id}]=${item.quantity}&`;
      }
      finalQuery = finalQuery.slice(0,-1);
      return finalQuery;
  }



}
